import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import Image from '../AppImage';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Home', path: '/homepage', icon: 'Home' },
    { name: 'Services', path: '/services-deep-dive', icon: 'Code' },
    { name: 'About', path: '/about-ecosystem', icon: 'Users' },

    { name: 'Contact', path: '/contact-consultation', icon: 'MessageCircle' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-header transition-brand ${
        isScrolled
          ? 'bg-background/95 backdrop-blur-brand shadow-brand-subtle'
          : 'bg-background/80 backdrop-blur-sm'
      }`}
    >
      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
          {/* Logo */}
          <Link
            to="/homepage"
            className="flex items-center space-x-3 group transition-brand"
            onClick={closeMenu}
          >
            <div className="relative">
              <div className="w-10 h-10 flex items-center justify-center group-hover:scale-105 transition-brand">
                <Image 
                  src="/logo.png"
                  alt="Manica Solutions Logo"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div className="absolute -inset-1 bg-brand-gradient rounded-brand opacity-0 group-hover:opacity-20 transition-brand blur-sm"></div>
            </div>
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-gradient-brand">Manica Solutions</h1>
              <p className="text-xs text-text-secondary -mt-1">Transforming Ideas Into Digital Reality</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-brand text-sm font-medium transition-brand flex items-center space-x-2 ${
                  isActivePath(item.path)
                    ? 'bg-secondary/10 text-secondary border border-secondary/20'
                    : 'text-text-primary hover:bg-muted hover:text-secondary'
                }`}
              >
                <Icon name={item.icon} size={16} />
                <span>{item.name}</span>
              </Link>
            ))}
          </nav>



          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden p-2 rounded-brand text-text-primary hover:bg-muted hover:text-secondary transition-brand"
            aria-label="Toggle menu"
          >
            <Icon name={isMenuOpen ? 'X' : 'Menu'} size={20} />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden bg-background/95 backdrop-blur-brand border-t border-border">
            <div className="px-4 py-4 space-y-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`block px-4 py-3 rounded-brand text-sm font-medium transition-brand flex items-center space-x-3 ${
                    isActivePath(item.path)
                      ? 'bg-secondary/10 text-secondary border border-secondary/20'
                      : 'text-text-primary hover:bg-muted hover:text-secondary'
                  }`}
                  onClick={closeMenu}
                >
                  <Icon name={item.icon} size={16} />
                  <span>{item.name}</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;